import { useQuery } from '@tanstack/react-query';
import { fetchReferralLink } from '../api/referralLinkApi';

/**
 * React Query hook to fetch the Financial Advisor's referral link
 * @returns Query result with referral link data
 */
export const useReferralLink = () => {
  return useQuery({
    queryKey: ['advisor', 'referralLink'],
    queryFn: fetchReferralLink,
    staleTime: Infinity,
  });
};

